import { RequestedOfferDetailRequest } from '@genial/services/dist/models';

import { AssetSelectedTypeMap } from '../../../../../../store/product/types';
import { AssetsMarketTypeEnum, PostProductBasketServiceProps } from '../../../../utils/types';
import { ProductsType } from '../../../DynamicAsset/constants';

export type OnlyBatchTicketProducts = Exclude<
  ProductsType,
  | 'clubs'
  | 'directTreasurySell'
  | 'equitySell'
  | 'fixedIncomeSell'
  | 'fundsSell'
  | 'privatePension'
  | 'publicOffers'
>;

export type BatchTicketPropertiesGetterMap = {
  [K in OnlyBatchTicketProducts]: (
    offer: AssetSelectedTypeMap[K],
    requestedOfferDetail?: Partial<RequestedOfferDetailRequest>
  ) => Omit<
    PostProductBasketServiceProps,
    'quantity' | 'requestedPrice' | 'requestedQuantity' | 'basketAdvisorOrderId' | 'offer'
  >;
};

export const propertiesMap: BatchTicketPropertiesGetterMap = {
  coes: (offer) => ({
    amount: offer.orderValue,
    requestedAmount: offer.orderValue,
    marketType: AssetsMarketTypeEnum.Coe,
    requestedOfferDetail: {},
  }),
  funds: (offer) => ({
    amount: offer.orderValue,
    requestedAmount: offer.orderValue,
    marketType: AssetsMarketTypeEnum.Fund,
    requestedOfferDetail: {},
  }),
  equity: (offer) => ({
    amount: offer.orderValue,
    requestedAmount: offer.orderValue,
    quantity: offer.orderQuantity,
    requestedPrice: offer.orderValue,
    requestedQuantity: offer.orderQuantity,
    marketType: AssetsMarketTypeEnum.Equity,
    orderType: 'Limit',
    offer: offer.quote,
    requestedOfferDetail: {},
  }),
  fixedIncome: (offer, requestedOfferDetail) => ({
    amount: offer.orderValue,
    requestedAmount: offer.orderValue,
    marketType: AssetsMarketTypeEnum.FixedIncome,
    requestedOfferDetail: requestedOfferDetail || {
      ...offer.orderFee,
    },
  }),
  directTreasury: (offer) => ({
    amount: offer.orderValue,
    requestedAmount: offer.orderValue,
    quantity: offer.orderQuantity,
    requestedPrice: offer.orderValue,
    requestedQuantity: offer.orderQuantity,
    marketType: AssetsMarketTypeEnum.Treasury,
    requestedOfferDetail: {},
  }),
};
